import * as actionTypes from './actionTypes';
import * as actionTypesSidebar from '@app/src/commons/sidebar/state/sidebar/actionTypes';

interface State {
  startDateErrorMessage: string;
  endDateErrorMessage: string;
  error: boolean;
}

const initialState = {
  startDateErrorMessage: '',
  endDateErrorMessage: '',
  error: false
};

export const validationDateRange = (state: State = initialState, action): State => {
  switch(action.type) {
    case actionTypes.SET_START_DATE_ERROR_MESSAGE:
      return {
        ...initialState,
        startDateErrorMessage: action.errorMessage,
        error: !!action.errorMessage
      };
    case actionTypes.SET_END_DATE_ERROR_MESSAGE:
      return {
        ...initialState,
        endDateErrorMessage: action.errorMessage,
        error: !!action.errorMessage
      }
    case actionTypesSidebar.RESET_APP_STATE:
      return initialState;
    default:
      return state;
  }
};
